














/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
import { State, Action } from "vuex-class";

import { NavigationService } from "../../NavigationServices/navigation";
import { ListItemDTO } from "../../Generated/ParticaAPI";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig } from "../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaAdminBase from "../Base/ParticaAdminBase.vue";
import StateMixin from "../../Mixins/StateMixin";

const namespace: string = "config";

@Component(
	{
		name: "FindAdmin",
		components: {
			ParticaError,
			ParticaRowContainer,
			ParticaColumnContainer,
			ActionListV2,
			ParticaCard,
			ParticaView
		},
		mixins: [StateMixin]
	})
export default class FindAdmin extends ParticaAdminBase {
	private query: string = "";
	private listdata = [] as ListItemDTO[];
	private listactions: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.ADMIN_SELECT_ACCOUNT, label: "Select" } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.ADMIN_SELECT_ACCOUNT: {
					this.setaccount(event.item.id);
					this.navigate("home", { id: event.item.id });
					this.ReloadMenu("");
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	private async search() {
		try {
			this.LoadingStart();
			this.listdata = await this.navigationService.getAccounts(this.query);
		} catch (error) {
			this.ShowErrorDialog(error, "error searching for account.");
		} finally {
			this.LoadingEnd();
		}
	}


	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Find Account";
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getAdminNav(0);
			this.navigationService = new NavigationService();
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
